import { X } from 'lucide-react';

export type ClearableSearchInputProps = {
  id?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /**
   * Tailwind classes for the <input> element. Omit `pr-*` and `px-*` — the
   * component always applies `!pr-8` so the clear button never overlaps text.
   */
  className?: string;
};

/**
 * Text input with an X clear button that appears when the field has content.
 * Wraps in a `relative` div so the button can be absolutely positioned.
 * Use in any filter-bar search field to satisfy the clearable-search-box
 * requirement across all list pages.
 */
export function ClearableSearchInput({
  id,
  value,
  onChange,
  placeholder,
  className,
}: ClearableSearchInputProps) {
  return (
    <div className="relative w-full">
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${className ?? ''} !pr-8`}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-amp-ink-muted hover:text-amp-ink dark:text-amp-dark-ink-muted dark:hover:text-amp-dark-ink"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
